import React, { forwardRef} from 'react';
import {TextField, TextFieldProps} from "@material-ui/core";

export const TextInputMaterial=forwardRef((props:TextFieldProps,ref)=>{
    return <TextField variant={"outlined"} margin={"normal"} inputRef={ref} fullWidth={true} {...props} />
});